<template>
    <div class="page">
      <img class="topbanner" src="@/assets/images/learn/banner.png" alt="">
      <div class="listBox">
          <img class="topbox" src="@/assets/images/learn/xcp.png" alt="">
          <div class="centerlist">
              <div class="phone" v-for="(item, index) in listData1" :key="index">{{item}}</div> 
          </div>
          <img class="topbox" src="@/assets/images/learn/bottom.png" alt="">
      </div>
  
      <div class="listBox huafei">
          <img class="topbox" src="@/assets/images/learn/hf.png" alt="">
          <div class="centerlist">
            <div class="phone" v-for="(item, index) in listData2" :key="index">{{item}}</div>
          </div>
          <img class="topbox" src="@/assets/images/learn/bottom.png" alt="">
      </div>
      <!-- <img class="topbox" src="@/assets/images/learn/bottomImg.png" alt=""> -->
  
    </div>
  </template>
  
  <script>
  import { reqLuckyXuan, reqLuckyPhone } from '@/api/lotteryWx.js' //接口方法
  //分享
  import { wxShare } from '@/utils/wxshare-wes2.com.js'
  import { Dialog } from 'vant';
  export default {
    name: 'index',
    components: {
    },
    data () {
      return {
        lotteryid:0,
        learnid:0,
        token:"",
        accessid:'', 
        openid:'', //微信用户openid   
        title:"",          
        showNotice:false,
        shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
        shareTitle:"",
        shareDesc:"", 
        listData1:[],
        listData2:[],
      }
    },  
    created (){
        this.lotteryid = 1;   
        this.accessid = this.$store.state.accessid;
        this.openid = this.$store.state.openid;
    },
    mounted () {
        this.getLuckyXuan();  
        this.getLuckyPhone();
    },  
    computed: {},
    methods: {
        async getLuckyXuan() {
            let result = await reqLuckyXuan({lotteryid:this.lotteryid});
            if(result.code==200) {
                this.listData1 = result.data;
            } else {
                this.$toast({
                icon: 'warning-o',
                message: result.msg
                });
            }
            
        },
        async getLuckyPhone() {
            let result = await reqLuckyPhone({lotteryid:this.lotteryid});
            if(result.code==200) {
                this.listData2 = result.data;
            } else {
                this.$toast({
                icon: 'warning-o',
                message: result.msg
                });
            }
            
        },
    }
    
  }
  </script>
  
  <style lang="scss" scoped>
  .page{
    width: 100vw;
    min-height: 100vh;
    background: #8e0c07;
    .topbanner{
      width: 100vw;
      height:auto;
      padding: 0px;
      margin: 0px;
    }
    .listBox{
      width: 100vw;
      margin-top: -70px;
      .topbox{
          display: block;
          width: 100%;
          height:auto;
          padding: 0px;
          margin: 0px;
      }
      .centerlist{
          background: url('@/assets/images/learn/center.png') repeat-y;
          background-size: 100%;
          min-height: 200px;
          color:#8e0c07;
          font-size: 30px;
          padding: 20px 30px;
          display: flex;
          flex-wrap: wrap;
          .phone{
              padding: 10px 20px;
          }
      }
    }
    .huafei{
      margin-top: 100px;
      padding-bottom: 200px;
    }
  }
  
  </style>